import { render, staticRenderFns } from "./WHOIS.vue?vue&type=template&id=d7a513de&lang=pug&"
import script from "./WHOIS.vue?vue&type=script&lang=js&"
export * from "./WHOIS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports